import React from 'react';
import './WhoAreWe.css';

const WhoAreWe: React.FC = () => {
    return (
        <div className="who-are-we-content">
            <div className="who-are-we-image-container">
                <img src="/files/WhosImage.jpg" alt="Who Are We" className="who-are-we-image" />
            </div>
            <p>
                We're a Turkish couple who’ve been together for over 20 years — we met in engineering school and have been cooking up life together ever since.
            </p>
            <p>
                Over the years, we've travelled across the Mediterranean, visiting Spain, France, Italy, Greece, Türkiye and Egypt — discovering new flavours, ingredients and food traditions along the way.
            </p>
            <p>
                We've always loved tasting, experimenting and creating good food — it's what connects us and brings us joy.
            </p>
            <p>
                We've been proud Cambourne residents since 2019. We first moved here from London for a job opportunity at Cambourne Business Park, but quickly fell in love with the area and decided to make it our home. Now, we'd love to share our passion for food with our local community.
            </p>
            <p>
                From our kitchen to your table — made with care, just like we'd make for family.
            </p>


        </div>
    );
};

export default WhoAreWe;
